import TagManager from '@sooro-io/react-gtm-module';
import type { EventProperties, Events } from 'shared/enums/events';
import { EnvVariables } from 'shared/env-variables';

let isAnalyticsInitialized = false;

/**
 * Initializes Google Tag Manager once for the current application session.
 */
export const initializeAnalytics = (): void => {
  const trackingId = EnvVariables.googleTagManagerId;

  if (!trackingId || isAnalyticsInitialized) {
    return;
  }

  try {
    TagManager.initialize({ gtmId: trackingId });
    isAnalyticsInitialized = true;
  } catch {
    // Analytics must not block application initialization.
    console.error('Failed to initialize analytics');
  }
};

/**
 * Publishes an analytics event to the Google Tag Manager data layer.
 *
 * @param eventName The event to publish.
 * @param properties Optional properties to include with the event.
 */
export const trackEvent = <T extends EventProperties>(
  eventName: Events,
  properties?: T,
): void => {
  try {
    TagManager.dataLayer({
      dataLayer: {
        event: eventName,
        ...properties,
      },
    });
  } catch {
    // Analytics must not block application behavior.
    console.error('Failed to track event', eventName, properties);
  }
};
